import { SpaceType } from '@onesource/schemas';
import { createFileRoute, getRouteApi } from '@tanstack/react-router';
import { ModuleDetailView } from 'src/features/community-hub/components/module-detail-view';
import { MyAnalyticsPage } from 'src/features/community-hub/components/my-analytics';
import { z } from 'zod';

/**
 * Sub-space detail. Path: /programs/{programSlug}/{moduleSlug}
 * A content module renders the lesson accordion; a "My Analytics" sub-space
 * renders the member's requirements. Both share the slug resolution and the
 * content-route context provided by the layout route.
 */
export const Route = createFileRoute('/_protected/programs/$programSlug/$moduleSlug/')({
  validateSearch: z.object({ sectionId: z.string().optional().catch(undefined) }),
  component: ModuleDetailRoute,
});

const layoutRoute = getRouteApi('/_protected/programs/$programSlug/$moduleSlug');

function ModuleDetailRoute() {
  const { sectionId } = Route.useSearch();
  const resolved = layoutRoute.useLoaderData();
  if (resolved.module?.spaceType === SpaceType.ANALYTICS) {
    return <MyAnalyticsPage />;
  }
  return <ModuleDetailView expandedSectionId={sectionId} />;
}
